import { useLocation } from "react-router-dom";

export const TV_BACK_HOME = "/tv";
export const DASHBOARD_BACK_HOME = "/";

/** Pass on Link/navigate from dashboard TV cards so sub-pages know where "back" goes. */
export function dashboardTvLinkState() {
  return { tvBack: DASHBOARD_BACK_HOME };
}

export function useTvBackPath(fallback = TV_BACK_HOME) {
  const location = useLocation();
  const fromState = location.state?.tvBack;
  if (typeof fromState === "string" && fromState.startsWith("/")) {
    return fromState;
  }
  return fallback;
}

export function getTvBackLabel(backPath) {
  return backPath === DASHBOARD_BACK_HOME ? "Back to dashboard" : "Back to TV";
}

/**
 * Keep tvBack when moving between TV sub-routes (e.g. exit yoga flow → picker).
 * - Dashboard entry passes tvBack: "/" — preserved as-is.
 * - TV entry often has no state — default to /tv so back never jumps to dashboard.
 */
export function preserveTvNavState(location) {
  const fromState = location.state?.tvBack;
  if (typeof fromState === "string" && fromState.startsWith("/")) {
    return { tvBack: fromState };
  }
  if (location.pathname.startsWith("/tv")) {
    return { tvBack: TV_BACK_HOME };
  }
  return undefined;
}
